module.exports = __webpack_public_path__ + "images/emoji/kissing.d4830f6fbe6cf11bc710.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/kissing.png
// module id = YcvO
// module chunks = 24